import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as Gallery} from "assets/img/gallery.svg";
import {greyishBlue300} from "assets/jss/main";

GalleryIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(Gallery)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true &&  {
            stroke: greyishBlue300
        }
    },
}));

export default function GalleryIcon(props) {
    return <StyledSvg {...props} />;
}
